export enum DashboardTexts {
    LABEL_BATTERY_STATE = 'Batteriestatus',
    BUTTON_SORT = 'Sortieren',
    BUTTON_ADD_TILE = 'Bereich hinzufügen',
}
